import { useEffect, useState } from 'react';

import { QuickGuideService } from '../QuickGuideService';

export const useQuickGuideService = (tableId: string | null): void => {
  useEffect(() => {
    if (!tableId) return;
    QuickGuideService.init(tableId);
  }, [tableId]);
};

export const useQuickGuideHintVisible = (): boolean => {
  const [isVisible, setIsVisible] = useState(QuickGuideService.isHintVisible);

  useEffect(() => {
    setIsVisible(QuickGuideService.isHintVisible);

    return QuickGuideService.addEventListener('hint-visibility-changed', (visible) => {
      setIsVisible(visible);
    });
  }, []);

  return isVisible;
};
